var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChartBarFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 21.75H21C21.1339 21.75 21.25 21.8661 21.25 22C21.25 22.1339 21.1339 22.25 21 22.25H3C2.86614 22.25 2.75 22.1339 2.75 22C2.75 21.8661 2.86614 21.75 3 21.75Z",
    fill: "#0747A6",
    stroke: "#0747A6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 8.88H5.59961C5.87673 8.88 6.09961 9.0994 6.09961 9.38V18.0001C6.09954 18.2739 5.87343 18.5001 5.59961 18.5001H4C3.72618 18.5001 3.50006 18.2739 3.5 18.0001V9.38C3.5 9.10615 3.72614 8.88 4 8.88Z",
    fill: "#0747A6",
    stroke: "#0747A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1992 5.69H12.7988C13.0727 5.69 13.2988 5.91614 13.2988 6.19V17.9996C13.2988 18.2734 13.0727 18.4996 12.7988 18.4996H11.1992C10.9254 18.4996 10.6992 18.2734 10.6992 17.9996V6.19C10.6992 5.91614 10.9254 5.69 11.1992 5.69Z",
    fill: "#0747A6",
    stroke: "#0747A6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9984 2H18.3984C17.8484 2 17.3984 2.45 17.3984 3V18C17.3984 18.55 17.8484 19 18.3984 19H19.9984C20.5484 19 20.9984 18.55 20.9984 18V3C20.9984 2.45 20.5484 2 19.9984 2Z",
    fill: "#0747A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartBarFilled);
export default __webpack_public_path__ + "static/media/chartBarFilled.046e3807f672baa460215051c0d6b7ac.svg";
export { ForwardRef as ReactComponent };